import React from "react";
import { Input, Select, Button, Checkbox } from "antd";

import FilterOptions from "./FilterOptions";

const Option = Select.Option;

const options = [
  {
    title: "Case Samples",
    active: true,
    items: [
      {
        title: "Homozyguous",
        state: true
      },
      {
        title: "Het-ambiguous",
        state: true
      },
      {
        title: "Compound heterozyguous",
        state: true
      },
      {
        title: "Heterozyguous",
        state: true
      },
      {
        title: "Haploinsufficient",
        state: true
      },
      {
        title: "Hemizyguous",
        state: true
      },
      {
        title: "Homozyguous",
        state: false
      }
    ],
    additional: true
  },
  {
    title: "Control Samples",
    active: false,
    items: [
      {
        title: "Homozyguous",
        state: true
      },
      {
        title: "Het-ambiguous",
        state: true
      },
      {
        title: "Compound heterozyguous",
        state: true
      },
      {
        title: "Heterozyguous",
        state: true
      },
      {
        title: "Haploinsufficient",
        state: true
      },
      {
        title: "Hemizyguous",
        state: true
      }
    ],
    additional: false
  }
];

class EditFilter extends React.Component {
  render() {
    return (
      <div className="filter">
        <div className="filter__title">Edit Filter</div>
        <div className="filter__group">
          <div className="filter__label label">Filter name</div>
          <div className="filter__row">
            <div className="filter__cell" style={{ width: 280 }}>
              <Input defaultValue="Genetich Analysis" />
            </div>
            <Button className="filter__btn">Rename</Button>
          </div>
          <div className="filter__row">
            <div className="filter__cell">
              <div className="filter__text">
                Use recommended settigns for: (Custom)
              </div>
              <Select
                className="filter__select"
                defaultValue="1"
                placeholder=""
              >
                <Option value="1">
                  Inferred gain or loss of function variants
                </Option>
              </Select>
            </div>
            <Button className="filter__btn">Set</Button>
          </div>
          <div className="filter__row">
            <div className="filter__cell" style={{ marginRight: 30 }}>
              <Checkbox>Pair/match from the same individuals</Checkbox>
            </div>
            <div className="filter__cell">
              <Checkbox>
                <div className="filter__row">
                  <div className="filter__text">Restrict to</div>
                  <Select
                    className="filter__select"
                    defaultValue="1"
                    placeholder=""
                  >
                    <Option value="1">transmitted</Option>
                  </Select>
                  <div className="filter__text">variants</div>
                </div>
              </Checkbox>
            </div>
          </div>
        </div>
        <div className="filter__details">
          {options.map((x, i) => (
            <FilterOptions options={x} key={i} />
          ))}
        </div>
        <div className="filter__foot">
          <Button type="primary">Apply</Button>
        </div>
      </div>
    );
  }
}

export default EditFilter;
